import $root from '@/proto/proto-bundle'

export const OauthService = {
  createTokenRequest (data) {
    const builder = $root.lookup('TokenRequest')
    const payload = builder.create(data)
    return builder.encode(payload).finish()
  },

  decodeTokenResponse (payload) {
    const container = $root.lookup('TokenResponse')
    return container.decode(new Uint8Array(payload))
  }
}
